const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace/calibration/devices/$deviceId/sessions/$sessionId.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace/calibration/devices/$deviceId/sessions/$sessionId.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { SessionWorkspacePendingState } from '@/features/calibration/components/SessionWorkspacePendingState';
import { calibrationSessionQuery } from '@/features/calibration/services/calibrationQueries';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_workspace/calibration/devices/$deviceId/sessions/$sessionId')({
  beforeLoad: requireCapabilities(has => has('calibration.read') || has('calibration.program.read')),
  loader: async ({
    context,
    params
  }) => {
    const detail = await context.queryClient.ensureQueryData(calibrationSessionQuery(params.sessionId));
    const sessionDeviceId = detail.session.input.deviceId;
    if (sessionDeviceId !== params.deviceId) {
      throw redirect({
        to: '/calibration/devices/$deviceId/sessions/$sessionId',
        params: {
          deviceId: sessionDeviceId,
          sessionId: params.sessionId
        }
      });
    }
    return detail;
  },
  pendingComponent: SessionWorkspacePendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});